/**
 * keyConstants.js
 * Talkroute
 *
 * Created by Vel Genov on 4/11/19
 * Copyright (c) 2019 Talkroute. All right reserved.
 */

/**
 * Constants representing various key names
 */
const keyConstants = {
  ENTER: "Enter",
  CODE_NUM_0: 96,
  CODE_NUM_9: 105,
  CODE_0: 48,
  CODE_9: 57,
  CODE_3: 51,
  CODE_8: 56,
  CODE_ENTER: 13,
  CODE_ESCAPE: 27,
  BACKSPACE: 8,
  DELETE: 46,

};

export default keyConstants;
